import React, { useContext, useEffect, useState } from 'react'
import { errorSchema, utils } from 'helper';
import { CommonInput, CommonModal, CommonTextarea, CustomSelect } from 'components'
import StorageService from 'utils/StorageServices/StorageServices';
import toast, { Toaster } from 'react-hot-toast';
import { createMaterialCategory } from '_services/materialServices/materialCategoryServices';
import { podReceivedData, updateLrProcess, uploadFiles } from '_services';
import { RiAddLargeFill } from "react-icons/ri";
import { createZone } from '_services/accountsServices/zoneServices';
import { createVehicleGroup } from '_services/accountsServices/vehicleGroupServices';
import { createVehicleDocType, editVehicleDocType } from '_services/accountsServices/vehicleDocTypeServices';
import { createStore, editStore } from '_services/workShopServices/workShopServices';

const formObj = {
    company_id: StorageService.getCompanyId(),
    name: '',
    code: '',
}

const AddEditStoreModel = (props) => {

    const { isOpen, closeModal, nextModal, categorySelection = () => { } , getDataCallBack = () => {}} = props;
    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (isOpen?.isDetails) {
            setFormValue((s) => ({
                ...s,
                company_id: isOpen?.company_id,
                name: isOpen?.name,
            }))
        }

    }, [isOpen?.isDetails])

    const handleOnChange = async (name, value) => {
        const stateObj = { ...formValue, [name]: value };
        if(name === 'code'){
            stateObj['code'] = value ? value?.trim() : ''
        }
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.addEditDocTypeSchema);
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    };

    const apiCallingFunction = async () => {
        try {
            if (isOpen?._id) {
                let obj = { ...formValue };
                delete obj.code;
                delete obj.company_id;
                const res = await editStore(obj)
                if (res?.responseCode == 200) {
                    setFormValue({});
                    setLoading(false);
                    if (res?.responseMessage) {
                        toast.success(res?.responseMessage);
                    }
                    closeModal(false);
                    props?.ApiCall()
                } else {
                    setLoading(false);
                    if (res?.responseMessage) {
                        toast.error(res?.responseMessage);
                    }
                }
            } else {
                let obj = { ...formValue }
                // delete obj.code;
                const res = await createStore(obj);
                if (res?.responseCode == 200) {
                    setFormValue({});
                    setLoading(false);
                    getDataCallBack(res?.data);
                    if (res?.responseMessage) {
                        toast.success(res?.responseMessage);
                    }
                    closeModal(false);
                    categorySelection(res?.data);
                    props?.ApiCall();
                } else {
                    setLoading(false);
                    if (res?.responseMessage) {
                        toast.error(res?.responseMessage);
                    }
                }
            }
        } catch (error) {
            setLoading(false);
        }
    }

    const handleClick = async (value) => {
        const validationResult = await utils?.checkFormError(formValue, errorSchema.addEditDocTypeSchema);
        if (utils?.isObjectKeyEmpty(validationResult)) {
            setLoading(true);
            apiCallingFunction();
            setFormError("");
        } else {
            setFormError(validationResult);
        }
    }

    useEffect(() => {
        if (isOpen?._id) {
            setFormValue((s) => ({
                ...s,
                company_id: StorageService.getCompanyId(),
                name: isOpen?.name,
                code: isOpen?.code,
                id: isOpen?._id,
            }))
        }
    }, [isOpen?._id])

    let inhanceProps = {
        ...props,
        submitTitle: loading ? 'Loading...' : props.submitTitle,
        disabled: loading,
        onSubmit: handleClick,
    }

    useEffect(() => {
        setFormValue((s) => ({
            ...s,
            company_id: StorageService.getCompanyId(),
        }))
    }, [])

    return (
        <div>
            <CommonModal {...inhanceProps}>
                <div className='addItem_body mt-2'>
                    <div className='colFlx'>
                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                label='Store Name *'
                                placeholder='Store Name *'
                                name='name'
                                value={formValue.name}
                                disabled={isOpen?.isDetails ? true : false}
                                focus={!!(typeof formError === "object" && formError?.name)}
                                error={!!(typeof formError === "object") ? formError?.name : ""}
                                maxLength="30"
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => utils.handleNameInputChange(e, handleOnChange)}
                            />
                        </div>
                        <div className='singleDiv'>
                            <CommonInput
                                type="text"
                                label='Store Code'
                                placeholder='Store Code'
                                name='code'
                                value={formValue.code}
                                disabled={isOpen?._id ? true : (isOpen?.isDetails ? true : false)}
                                focus={!!(typeof formError === "object" && formError?.code)}
                                error={!!(typeof formError === "object") ? formError?.code : ""}
                                maxLength="10"
                                onInput={utils.maxLengthCheck}
                                // onChange={(e) => utils.handleNoSpecialCharInputChange(e, handleOnChange)}
                                onChange={({ target: { name, value } }) =>
                                    handleOnChange(name, value)
                                }
                            />
                            {!isOpen?.isDetails ? <p className='_bottomPLine'>Leave Blank to Auto generate</p> : <></>}
                        </div>
                    </div>
                </div>
            </CommonModal>
            {/* <div className='offBack_drop'></div> */}

        </div>
    )
}

export default AddEditStoreModel